export default class Permission {

    static ROUTE_GROWERS = 'ROUTE_GROWERS';
    static ROUTE_SHIPS = 'ROUTE_SHIPS';
    static ROUTE_USERS = 'ROUTE_USERS';
    static ROUTE_PARCELS = 'ROUTE_PARCELS';
    static ROUTE_SECTIONS = 'ROUTE_SECTIONS';

    static ROUTE_OVERVIEW_PERIOD = 'ROUTE_OVERVIEW_PERIOD';
    static ROUTE_COHORTS = 'ROUTE_COHORTS';
    static ROUTE_COHORT_DETAIL = 'ROUTE_COHORT_DETAIL';
    static ROUTE_ACTIONS_EDIT = 'ROUTE_ACTIONS_EDIT';
    static ROUTE_WATER_INSIGHTS = 'ROUTE_WATER_INSIGHTS';

    static MUTATE_PARCELS = 'MUTATE_PARCELS';
    static MUTATE_SECTIONS = 'MUTATE_SECTIONS';

    static all() {

        return Object.keys(Permission);
    }
}
